import { UserGeneratedContentUI } from "./UserGeneratedContentUI";
import { StandardProps } from "../componentMap";
import Script from "next/script";

const USER_CONTENT_CLIENT_ID = "web-pdp-scaffold-ui";

export function UserGeneratedContent({
  product,
  runtimeConfig,
  experiencesRawObject,
}: Pick<StandardProps, "product" | "runtimeConfig" | "experiencesRawObject">) {
  return (
    <>
      <Script
        src="/user-content-ui/static/js/jl-user-content.js?includeCoreAssets=false"
        type="text/javascript"
        defer
      />
      <UserGeneratedContentUI
        productId={product.aliases.pimProductId}
        productURL={product.pdpURL.url}
        apiKey={runtimeConfig.userGeneratedContentApiKey}
        clientId={USER_CONTENT_CLIENT_ID}
        experiencesRawObject={experiencesRawObject}
        isBrandPromise={true}
      />
    </>
  );
}
